import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.UpdateJob = {
  displayName: 'UpdateJob',

  component: React.createClass({
    getInitialState: function() {
      return {
        loading: true
      }
    },

    componentDidMount: function() {
      const $modalFooter = $('#job-modal').find('.modal-footer')
      $modalFooter.hide()

      let job = Job.Data

      var subcategories = job.categories.map(function(subcategory){
        return {sub_category_id: subcategory.id}
      })

      var index = -1

      for (var i = 0; i < subcategories.length; ++i) {
          if (subcategories[i].sub_category_id === Job.Data.category_id) {
              index = i;
              break;
          }
      }

      subcategories.splice(index,1)[0]

      let jobData = {
        id:                            Job.Data.id,
        budget:                        job.minBudget,
        min_budget:                    job.minBudget,
        max_budget:                    job.maxBudget,
        schedule:                      buildJobSchedule(),
        description:                   JobWizard.buildDescription(),
        contact_preference:            Job.Data.contactPreference,
        job_sub_categories_attributes: subcategories
      }

      $.ajax({
        url: '/job_wizard/update_job',
        method: "POST",
        data: jobData
      })
      .done(function(data) {
        Job.Data.id = data.job_id
        Job.Data.with_cc = data.with_cc
        Job.Data.cc_number = data.cc_number
        finalizeJobPosting()
        SS.appFn.appMsg({ id: data.job_id, status: 'completed' }) // used by mobile app for controlling the flow
      })

      function finalizeJobPosting() {

        let closureData = Job.Data.closureSurvey
        let hasClosureData = (closureData.job && typeof closureData.job.id !== 'undefined') ? true : false
        var slideTo = ''

        if (hasClosureData) {
          slideTo = JobWizard.HasJobBeenDoneYet
          if (JobWizard.Utils.Products.hasSelectedJobUpgrades()) {
            advanceToJobUpgradesStep()
          } else {
            JobWizard.Emitter.emit('job:wizard:advanceToStep', slideTo)
          }
        }
        else {
          redirectToJobPage()
        }

        function advanceToJobUpgradesStep() {
          JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.JobUpgrades)
        }

        function redirectToJobPage(){
          document.location.href = redirectUrl()
        }

        function redirectUrl() {
          let jobID = Job.Data.id

          switch (Job.Data.referrer.cta) {
            case 'profile': {
              return `/jobs/${jobID}/profilejob?successful_job=true`
            }
            case 'business_directory_card': {
              return `/jobs/${jobID}/bcardjob?successful_job=true`
            }
            default: {
              return `/jobs/${jobID}/posted?successful_job=true`
            }
          }
        }
      }

      function buildJobSchedule() {
        if (job.schedule !== 'on_a_particular_date') { return "" }

        var [day, month, year] = job.scheduleDate.split("/")

        return new Date([year, month, day])
      }
    },

    render: function() {
      return (
        <div className="modal-body job-form-body">
          <h3>Updating your job details...
            <div className="spinner-icon text-center" style={{marginLeft: '15px'}}/>
          </h3>
        </div>
      )
    }
  })
}

/* build the description object for the job */
JobWizard.buildDescription = function() {
  const job = Job.Data;

  let description = `${job.description}`

  if (job.extraDetails) {
    buildExtraDetails()
  }

  switch(job.schedule) {
  case 'this_week':
    description += '\n\nSchedule: Need job done this week\n\n';
    break;
  case 'next_couple_of_weeks':
    description += '\n\nSchedule: Need job done in the in the next few weeks\n\n';
    break;
  case 'on_a_particular_date':
    description += `\n\nSchedule: Need job done on ${job.scheduleDate}\n\n`
    break;
  case 'asap_urgent':
    description += '\n\nSchedule: Need job done urgently\n\n'
    break;
  default:
    description += '\n\nSchedule: I’m flexible\n\n';
  }

  if (job.budget === 'yes') {
    description += `\nBudget: ${stringUtils.capitalise(job.budgetType)}`
  }
  else if (job.budgetType !== 'price_range' && job.budgetType !== 'set_price') {
    description += `\nBudget: Not Specified`
  }

  if (job.budgetType === 'price_range' && job.budgetPriceRange !== null) {
    if (job.minBudget == '5001' && job.maxBudget == '5001') {
      description += `\nBudget: More than $5000`
    } else {
      description += `\nBudget: $${job.minBudget} - $${job.maxBudget}`
    }
  }

  if (job.budgetType === 'set_price' && job.budgetSetPriceRange !== null) {
    let price = job.budgetSetPriceRange
    description += `\nBudget: $${price}`
}

  if (job.siteVisit !== null)
  {
    let siteVisit = SS.appFn.stringUtils.capitalise(job.siteVisit.replace(/_/g, ' '))
    description += `\n\nSite Visit: ${siteVisit}`

    if (job.siteVisitTime !== null) {
      description += `\nVisit during: ${SS.appFn.stringUtils.capitalise(job.siteVisitTime)}`
    }
  }

  function buildExtraDetails() {
    description += '\n\n\nSpecific Job Details: \n'
    formatExtraDetails()

    function formatExtraDetails() {
      Object.keys(job.extraDetails).forEach(function(descriptionKey) {
        if(Array.isArray(job.extraDetails[descriptionKey])) {
          description += `\n ${descriptionKey}: \n${addLeadingHyphens(descriptionKey)} \n`
        } else {
          description += `\n ${descriptionKey}: ${job.extraDetails[descriptionKey]} \n`
        }
      })
    }

    function addLeadingHyphens(key) {
      return job.extraDetails[key].map((el) => '  - ' + el).join('\n')
    }
  }

  return description
}
